'use strict';

import { debounce, isBreakpointActive } from './helpers';

require('modaal');

const $document = $(document);
const $body = $('body');

if (!isBreakpointActive('xsm')) {
    $('.js-gallery-image').modaal({
        type: 'image',
    });

    $('.js-gallery-video').modaal({
        type: 'video'
    });
}
